import { createContext, useContext } from 'react';
import useFindUser from './hooks/useFindUser';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const { user, setUser, isLoading, setLoading, findUser } = useFindUser();

  return <UserContext.Provider value={{ user, setUser, isLoading, setLoading, findUser }}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) throw Error('Component cannot call `useUser` unless wrapped with a `UserProvider`');

  return context;
};
